<template>
  <div class="aboutWrap">
    <h4 class="subTitle">ABOUT</h4>
    <div class="aboutTable">
      <div class="leftTable">

        <div class="tableRow">
          <strong class="aboutTableLabel">상&nbsp;&nbsp;&nbsp;호</strong>
          <p class="aboutTableContent" v-html="about.companyName"/>
        </div>

        <div class="tableRow">
          <strong class="aboutTableLabel">업&nbsp;&nbsp;&nbsp;태</strong>
          <p class="aboutTableContent" v-html="about.businessConditions"/>
        </div>

        <div class="tableRow">
          <strong class="aboutTableLabel">플랫폼</strong>
          <p class="aboutTableContent" v-html="about.platform"/>
        </div>

        <div class="tableRow">
          <strong class="aboutTableLabel">조&nbsp;&nbsp;&nbsp;직</strong>
          <p class="aboutTableContent" v-html="about.departments"/>
        </div>

        <div class="tableRow">
          <strong class="aboutTableLabel">E-mail</strong>
          <p class="aboutTableContent" v-html="about.email"/>
        </div>

      </div>
      <div class="rightTable">
        <div class="tableRow">
          <strong class="aboutTableLabel">대표자</strong>
          <p class="aboutTableContent" v-html="about.ceoName"/>
        </div>

        <div class="tableRow">
          <strong class="aboutTableLabel">업&nbsp;&nbsp;&nbsp;종</strong>
          <p class="aboutTableContent" v-html="about.typeOfBusiness"/>
        </div>

        <div class="tableRow">
          <strong class="aboutTableLabel">개&nbsp;&nbsp;&nbsp;발</strong>
          <p class="aboutTableContent" v-html="about.typeOfProduct"/>
        </div>

        <div class="tableRow">
          <strong class="aboutTableLabel">인&nbsp;&nbsp;&nbsp;력</strong>
          <p class="aboutTableContent" v-html="about.humanResources"/>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "about" ,
        computed : {
          ...mapGetters({
            about: 'informationStore/getInformationAbout',
          })
        },
        created () {

        },
        mounted () {

        },
        data () {
          return {
          }
        },
        methods : {

        }
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/About.vue